import React from 'react';
import cn from 'clsx';
import { string, bool, oneOf } from 'prop-types';

/**
 * PianoInlineTemplate component.
 */
const PianoInlineTemplate = ({
  position,
  isFixed,
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: cn(className, 'piano-inline-template', position === 'high' && 'container container--no-gutters')
}, /*#__PURE__*/React.createElement("div", {
  className: `piano-inline-template__content js-piano-${position} piano-inline-template__content--${position}` + (isFixed ? " piano-inline-template__content--fixed" : "")
}));
PianoInlineTemplate.defaultProps = {
  className: null,
  isFixed: false
};
PianoInlineTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  /** dictates the place of the component in the document */
  position: oneOf(['high', 'low', 'inline']).isRequired,
  /** positions the element as fixed when true */
  isFixed: bool,
  /** Additional class names to add to the component root. */
  className: string
} : {};
export default PianoInlineTemplate;